import { css } from '@emotion/core'
import styled from '@emotion/styled'
import { MQ } from '@css/constants'

export const MobileOnly = styled('div')(css`
  ${MQ.DESKTOP} {
    display: none;
  }
`)

export const DesktopOnly = styled('div')(css`
  display: none;

  ${MQ.DESKTOP} {
    display: block;
  }
`)
